<template>
  <div class="home-workbench">
    <header class="home-welcome"><div><h1>工作台</h1><p>把日常安排妥当，把更多时间留给教学。</p></div><div class="home-date"><v-icon size="17">mdi-calendar-blank-outline</v-icon><span>{{displayDate}}</span></div></header>
    <div v-if="homeLoad.month.error" class="home-feedback" role="alert">本月数据加载失败<button type="button" @click="getMonthData">重新加载</button></div>
    <section class="home-metrics" aria-label="本月经营概览" :aria-busy="homeLoad.month.loading">
      <article class="home-metric"><div class="home-metric-label">本月缴费<span class="home-metric-icon tone-red"><v-icon size="18">mdi-wallet-outline</v-icon></span></div><div class="home-metric-value"><small>¥</small>{{metricText(monthData.rechargeAmount)}}<span>元</span></div><div class="home-metric-foot"><i class="home-dot tone-red-dot" />本月累计缴费</div></article>
      <article class="home-metric"><div class="home-metric-label">本月新入学员<span class="home-metric-icon tone-blue"><v-icon size="18">mdi-account-multiple-outline</v-icon></span></div><div class="home-metric-value">{{metricText(monthData.newStudentCount)}}<span>人</span></div><div class="home-metric-foot">总在读学员<strong>{{metricText(monthData.inShopCount)}}</strong>人</div></article>
      <article class="home-metric"><div class="home-metric-label">本月总消课<span class="home-metric-icon tone-gold"><v-icon size="18">mdi-book-open-page-variant-outline</v-icon></span></div><div class="home-metric-value">{{metricText(monthData.reduceClassHours)}}<span>课时</span></div><div class="home-metric-foot">课时模式 <strong>{{metricText(monthData.reduceTimeHours)}}</strong><template v-if="monthData.reduceCashHours > 0"><span class="home-mini-divider" />金额模式 <strong>{{metricText(monthData.reduceCashHours)}}</strong></template></div></article>
      <article class="home-metric"><div class="home-metric-label">本月消课收入<span class="home-metric-icon tone-green"><v-icon size="18">mdi-chart-bar</v-icon></span></div><div class="home-metric-value"><small>¥</small>{{metricText(monthData.recordRevenueAmount)}}<span>元</span></div><div class="home-metric-foot"><i class="home-dot tone-green-dot" />本月累计消课收入</div></article>
    </section>
    <div class="home-columns">
      <div class="home-primary">
        <section class="home-panel home-shortcuts"><div class="home-section-head"><h2>常用功能</h2><span>让日常操作更顺手</span></div><div class="home-shortcut-grid">
          <button type="button" class="home-shortcut" @click="toLink('/edu/student/list')"><span class="home-shortcut-icon tone-red"><v-icon>mdi-account-plus-outline</v-icon></span><span>新增学员</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/sys/employee/list')"><span class="home-shortcut-icon tone-blue"><v-icon>mdi-account-tie-outline</v-icon></span><span>新增老师</span></button>
          <button v-if="financialAccess.courseAccount && modeEnabled('1')" type="button" class="home-shortcut" @click="toLink('/financial/course/account/index')"><span class="home-shortcut-icon tone-green"><v-icon>mdi-wallet-outline</v-icon></span><span>课时账户充值</span></button>
          <button v-if="modeEnabled('2')" type="button" class="home-shortcut" @click="toLink('/financial/cash/account/index')"><span class="home-shortcut-icon tone-purple"><v-icon>mdi-cash-multiple</v-icon></span><span>金额账户充值</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/edu/class/list')"><span class="home-shortcut-icon tone-red"><v-icon>mdi-calendar-plus</v-icon></span><span>建班排课</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/sys/course/list')"><span class="home-shortcut-icon tone-blue"><v-icon>mdi-book-open-outline</v-icon></span><span>新增课程</span></button>
          <button v-if="financialAccess.tradeFlow" type="button" class="home-shortcut" @click="toLink('/financial/trade/flow/list')"><span class="home-shortcut-icon tone-green"><v-icon>mdi-receipt</v-icon></span><span>收支明细</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/exchange/order/list')"><span class="home-shortcut-icon tone-purple"><v-icon>mdi-gift-outline</v-icon></span><span>积分兑换</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/edu/schedule/list')"><span class="home-shortcut-icon tone-red"><v-icon>mdi-calendar-month-outline</v-icon></span><span>课表日历</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/sys/classroom/list')"><span class="home-shortcut-icon tone-blue"><v-icon>mdi-door-open</v-icon></span><span>新增教室</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/edu/class/record/detail/list')"><span class="home-shortcut-icon tone-green"><v-icon>mdi-clipboard-check-outline</v-icon></span><span>点名记录</span></button>
          <button type="button" class="home-shortcut" @click="toLink('/edu/potential/list')"><span class="home-shortcut-icon tone-purple"><v-icon>mdi-bullseye-arrow</v-icon></span><span>意向学员跟进</span></button>
        </div></section>
        <section class="home-panel"><div class="home-section-head"><h2><v-icon size="18" color="#bb8145">mdi-bell-outline</v-icon>数据预警</h2><span>及时跟进，从容安排</span></div>
          <div v-if="homeLoad.warn.error" class="home-feedback" role="alert">预警数据加载失败<button type="button" @click="getWarnData">重试</button></div>
          <div v-else-if="homeLoad.warn.loading" class="home-empty" role="status">正在加载预警数据…</div>
          <div v-else-if="!warnData.length" class="home-empty">暂无预警数据</div>
          <div v-else class="home-warning-grid"><button v-for="(item,index) in warnData" :key="item.dataType || index" type="button" class="home-warning" @click="toWarnPage(item)"><span class="home-warning-name">{{item.caption}}</span><span class="home-warning-count">{{metricText(item.count)}}<v-icon size="16">mdi-chevron-right</v-icon></span><span class="home-warning-hint">查看详情</span></button></div>
        </section>
        <section class="home-wechat"><span class="home-wechat-icon"><v-icon>mdi-wechat</v-icon></span><div><h3>手机端，让管理随时在手</h3><p>关注公众号并登录教师端，及时接收消息通知。</p></div><button type="button" @click="wxQrcodeShow=true">立即关注<v-icon size="16">mdi-chevron-right</v-icon></button></section>
        <section class="home-panel home-help"><div class="home-section-head"><h2>操作说明</h2><a href="https://www.yuque.com/yundou-fu7fp/ey68az/chzomnax7p5g7qyb" target="_blank" rel="noopener noreferrer">使用指南<v-icon size="14">mdi-open-in-new</v-icon></a></div><div class="home-help-links"><a href="https://www.yuque.com/yundou-fu7fp/ey68az/tfl25rnl7x3ua0di" target="_blank" rel="noopener noreferrer">学员缴费充值<v-icon size="14">mdi-chevron-right</v-icon></a><a href="https://www.yuque.com/yundou-fu7fp/ey68az/hoext0r1ogc5fnf6" target="_blank" rel="noopener noreferrer">给学员分班<v-icon size="14">mdi-chevron-right</v-icon></a><a href="https://www.yuque.com/yundou-fu7fp/ey68az/aduahi3dhsemkiqb" target="_blank" rel="noopener noreferrer">核销课时<v-icon size="14">mdi-chevron-right</v-icon></a><a href="https://www.yuque.com/yundou-fu7fp/ey68az/aaith3zcc5pia8tn" target="_blank" rel="noopener noreferrer">积分奖励<v-icon size="14">mdi-chevron-right</v-icon></a></div></section>
      </div>
      <div class="home-secondary">
        <section class="home-panel home-todos"><div class="home-section-head"><h2>待办事项<i class="home-todo-dot" /></h2><v-btn icon small aria-label="刷新待办" :loading="homeLoad.todo.loading" @click="getEduWaitCountList"><v-icon size="19">mdi-refresh</v-icon></v-btn></div><p class="home-todo-intro">待处理事项，一眼掌握</p>
          <div v-if="homeLoad.todo.error" class="home-feedback" role="alert">待办加载失败<button type="button" @click="getEduWaitCountList">重试</button></div>
          <div v-else-if="homeLoad.todo.loading" class="home-empty" role="status">正在加载待办…</div>
          <div v-else-if="!waitTodoCount.length" class="home-empty">暂无可处理的待办事项</div>
          <div v-else class="home-todo-list"><button v-for="(item,index) in waitTodoCount" :key="item.dataType || index" type="button" class="home-todo-row" @click="waitTodoItemClicked(item)"><v-icon size="19">{{todoIcon(item.dataType)}}</v-icon><span>{{item.title}}</span><strong>{{metricText(item.count)}}</strong><v-icon size="16">mdi-chevron-right</v-icon></button></div><p class="home-todo-note">课后及时处理，教学记录不遗漏</p>
        </section>
        <section class="home-panel home-income"><div class="home-section-head"><h2>缴费与消课收入</h2><span class="home-month-label">本月</span></div><div v-if="homeLoad.month.loading" class="home-empty">正在加载图表…</div><div v-else-if="homeLoad.month.error" class="home-empty">请重新加载本月数据</div><home-income-comparison v-else :recharge="monthData.rechargeAmount" :revenue="monthData.recordRevenueAmount" /></section>
      </div>
    </div>
    <section class="home-support"><div><v-icon size="18">mdi-headset</v-icon><strong>我们随时为你提供帮助</strong></div><div><span>业务咨询</span><b>橙子</b><a href="tel:15618660303">156 1866 0303</a></div><div><span>技术支持</span><b>黄工</b><a href="tel:18616658240">186 1665 8240</a></div><span>微信同号</span></section>
		<!-- 功能介绍dialog -->
		<v-dialog title="系统功能" v-model="desc.dialog" width="800px" persistent>
			<v-card>
				<v-card-title>系统功能介绍</v-card-title>
				<v-card-text>
					<iframe src="https://console.youkeya.cn/guide/yky_desc.html?v=1.0" border="0" width="760px" height="500px" frameborder="0"></iframe>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="desc.dialog=false">关闭</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 微信二维码dialog -->
		<v-dialog title="系统功能" v-model="wxQrcodeShow" width="400px" persistent>
			<v-card>
				<v-card-title>
					<span>关注“有课丫”公众号</span>
					<v-spacer></v-spacer>
					<v-icon @click="wxQrcodeShow=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5 d-flex justify-center">
					<div class="d-flex flex-column align-center mb-5">
						<v-avatar size="280" rounded>
							<v-img src="https://photo.youkeya.cn/assets/icon/yky_gzh_qrcode.jpeg"></v-img>
						</v-avatar>
						<span>关注后点击“教师入口”登录系统</span>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- 待核销 -->
		<waitApproveBox :show="waitApproveShow" @cancel="waitApproveShow=false"></waitApproveBox>
		<!-- 待点评 -->
		<waitRateBox :show="waitRateShow" @cancel="waitRateShow=false" @updateCount="getEduWaitCountList"></waitRateBox>
		<!-- 待奖励积分 -->
		<waitGivePointBox :show="waitGivePointShow" @cancel="waitGivePointShow=false" @updateCount="getEduWaitCountList"></waitGivePointBox>

		<!-- 课时不足提醒组件 -->
		<courseAccountWarn :show="courseAccountWarnShow" @cancel="courseAccountWarnShow=false"></courseAccountWarn>
		<!-- 金额不足提醒组件 -->
		<cashAccountWarn :show="cashAccountWarnShow" @cancel="cashAccountWarnShow=false"></cashAccountWarn>
		<!-- 按班级点评 -->
		<recordWaitRateBox :show="recordWaitRateShow" @cancel="recordWaitRateShow=false"></recordWaitRateBox>
	</div>

</template>
<script>
    import HomeIncomeComparison from '../../../components/HomeIncomeComparison.vue'
    import { metricText } from '../config/incomeChart'

	import {accountModes,accountModeEnabled} from '../../../config/accountModes'
	import utils from "../../../config/utils"
	import waitApproveBox from "../../../components/wait_approve_box.vue"
	import waitRateBox from "../../../components/wait_rate_box.vue"
	import waitGivePointBox from "../../../components/wait_give_point_box.vue"
	import courseAccountWarn from "../../../components/course_account_warn.vue"
	import cashAccountWarn from "../../../components/cash_account_warn.vue"
	import recordWaitRateBox from "../../../components/record_wait_rate_box.vue"
	export default {
		name: "index",
		components:{
			waitApproveBox,waitRateBox,waitGivePointBox,courseAccountWarn,cashAccountWarn,recordWaitRateBox,HomeIncomeComparison
		},
		data() {
			return {
				dialog: false,
				shopId:"",
				createStudentShow:false, // 创建学员
				createClassShow:false, // 创建班级
				waitTodoCount:[],
				waitApproveShow:false,
				waitRateShow:false,
				waitGivePointShow:false,
				courseAccountWarnShow:false,
				cashAccountWarnShow:false,
				wxQrcodeShow:false,
				monthData:{},// 月度数据
				financialAccess: {},
 accountModes,
				warnData:[],// 数据预警
                displayDate: new Date().toLocaleDateString('zh-CN', {year:'numeric',month:'long',day:'numeric',weekday:'long'}),
                homeLoad: {month:{loading:true,error:false},todo:{loading:true,error:false},warn:{loading:true,error:false}},
				desc:{
					dialog:false,
					url:"",
				},
				recordWaitRateShow:false

			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.loadFinancialAccess();

			this.getEduWaitCountList();
			this.getMonthData();
			this.getWarnData();
		},
		methods: {
 modeEnabled(mode){return accountModeEnabled(mode, utils.getCurrentShopId())},
			async loadFinancialAccess() {
				this.financialAccess = {};
				try {
					const { data } = await this.axios.get('/financial/access');
					if (data.code === 200 && data.data) this.financialAccess = data.data;
				} catch (error) { /* Permission failures keep financial shortcuts hidden. */ }
			},
            metricText,
            todoIcon(type) { return ({waitApprove:'mdi-clipboard-check-outline',waitRate:'mdi-comment-text-outline',waitRecordRate:'mdi-comment-multiple-outline',waitGivePoint:'mdi-gift-outline',waitApproveAbsence:'mdi-calendar-alert'})[type] || 'mdi-checkbox-marked-circle-outline' },
            async loadHomeSection(section, url, assign) {
                const state = this.homeLoad[section]
                state.loading = true; state.error = false
                try {
                    const { data } = await this.axios.get(url)
                    if (!data || data.code !== 200) throw new Error('Unable to load section')
                    assign(data.data)
                } catch (_) { state.error = true }
                finally { state.loading = false }
            },
			createStudentSuccess(){
				this.createStudentShow= false;
			},
			createClassSuccess(){
				this.createClassShow = false;
			},
			toPage(item) {
				this.$router.push(item.url);
			},
			toLink(link) {
				this.$router.push(link);
			},
			toStudentList(){
				this.$router.push({
					path:'/edu/student/list',
					query:{
						isJoinClass:"0"
					}
				});

			},
			toClassList(maxCount){
				this.$router.push({
					path:'/edu/class/list',
					query:{
						minLessonCount:"0",
						maxLessonCount:maxCount
					}
				});
			},
			waitTodoItemClicked(item){
				if(item.dataType=="waitApprove"){
					this.waitApproveShow=true;
				}else if (item.dataType == "waitRate"){
					this.waitRateShow = true;
				}else if (item.dataType == "waitGivePoint"){
					this.waitGivePointShow = true;
				}else if (item.dataType == "waitApproveAbsence"){
					this.$router.push('/edu/absence/list');
				}else if (item.dataType == "waitRecordRate"){
					this.recordWaitRateShow = true;
				}
			},
            getEduWaitCountList() {
                return this.loadHomeSection('todo', `/edu/teacher/edu/wait/todo/count?shopId=${this.shopId}`, data => { this.waitTodoCount = Array.isArray(data) ? data : [] })
            },
            getMonthData() {
                const shopId = utils.getCurrentShopId()
                return this.loadHomeSection('month', `/report/home/month/data?shopId=${shopId}`, data => { this.monthData = data && typeof data === 'object' && !Array.isArray(data) ? data : {} })
            },
            getWarnData() {
                return this.loadHomeSection('warn', `/report/home/warn/data?shopId=${this.shopId}`, data => { this.warnData = Array.isArray(data) ? data : [] })
            },
			toWarnPage(item){
				if (item.dataType == 'noClass'){
					this.toStudentList();
				}else if (item.dataType=='recordLess'){
					this.toClassList(item.warnValue);
				}else if (item.dataType=='hoursLess'){
					this.courseAccountWarnShow =true;
				}else if (item.dataType=='cashLess'){
					this.cashAccountWarnShow =true;
				}
			}
		},

	}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/home-ui.scss";
</style>
